"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function AboutPrimeLaundry() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const imageContainerRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageContainerRef.current) return;
      const rect = imageContainerRef.current.getBoundingClientRect();
      const scrollPosition = window.scrollY;
      const elementTop = rect.top + scrollPosition;
      const windowHeight = window.innerHeight;
      if (rect.top < windowHeight && rect.bottom > 0) {
        const offset = (scrollPosition - elementTop + windowHeight) * 0.02;
        setParallaxOffset(offset);
      }
    };
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section id="about-prime-laundry" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={contentRef} className={`space-y-6 ${contentVisible ? "animate-reveal" : "opacity-0"}`}>
            <h2 className="font-display font-semibold tracking-tight text-4xl md:text-5xl lg:text-6xl text-foreground">
              About Prime Laundry
            </h2>
            
            <div className="space-y-4 text-foreground/80 text-base md:text-lg leading-relaxed">
              <p>
                Prime Laundry is a planned, modern self-service laundromat concept designed for Spartanburg, South Carolina. The vision emphasizes clean, safe, well-lit spaces with thoughtful layout and high-efficiency equipment.
              </p>
              
              <p>
                This concept is built on operational discipline, efficient customer flow, and modern systems intended to support predictable performance and ease of operation over the long term.
              </p>
              
              <p>
                Designed to communicate professional vision and operational intent to business owners, brokers, and lenders, Prime Laundry showcases a disciplined capital approach and transaction readiness.
              </p>
            </div>
          </div>

          {}
          <div ref={imageContainerRef} className="relative w-full h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden rounded-md">
            <div className="absolute inset-0 w-full h-full" style={{
            transform: `translateY(${parallaxOffset}px)`,
            transition: "transform 0s linear"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541714/img/prime_laundry_facility_illustration.png" alt="Prime Laundry planned facility illustration" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}